'use strict';
var logger = require('./logger.js');
var localStorageUtils = require('./local-storage-utils.js');
var localStorageConstants = require('./local-storage-constants.js');
var sourcepointConstants = require('./sourcepoint-constants.js');

var covatic = window.covaticBrowserSDK;
const mediaAssetDuration = 3600; // Set actual duration if available
const playHeadPosition = 300;    // Set playhead position based on context
const audienceProfileKey = '_audienceProfile';

async function onConsentGranted() {
    var mediaConsumptionData = null;

    // Check if MediaConsumptionData exists in the window object
    if (window.MediaConsumptionData !== null && window.MediaConsumptionData !== undefined) {
        logger.info('Covatic media consumption data available.');
        mediaConsumptionData = window.MediaConsumptionData;
    }

    // Initialize the Covatic Browser SDK using the client config
    covatic.Client(mediaConsumptionData.clientConfig);

    // Notify Covatic that user consent has been granted
    covatic.notifyConsent(true);
    logger.info('Covatic notified: consent granted.');

    // Wait until the Covatic SDK is ready before proceeding
    const isSdkReady = await covatic.isReady();

    if (isSdkReady) {
        logger.info('Covatic SDK is ready.');

        // Notify Covatic of the user's subscription level (guest account in this case)
        covatic.notifySubscription('guestAccount');
        logger.info('Covatic subscription level notified.');

        // Notify Covatic of media consumption, if mediaConsumptionData is available
        if (mediaConsumptionData) {
            covatic.notifyEvent(
                new covatic.MediaConsumption(
                    '', // mediaId or assetId (empty not applicable)
                    mediaConsumptionData.mediaAssetTitle,
                    { 'cvc_description': mediaConsumptionData.cvcDescription },
                    mediaConsumptionData.mediaTag,
                    mediaConsumptionData.mediaSubsection,
                    mediaAssetDuration,  // Duration of the media
                    playHeadPosition,    // Current playback position
                    covatic.MediaConsumption.Action.commenceMedia,
                    covatic.MediaConsumption.Type.text // Media type (e.g., text)
                )
            );
            logger.info('Covatic media consumption notified.');
        } else {
            logger.warn('Covatic no media consumption data available.');
        }

        // Fetch and handle audience profiles from Covatic
        const audienceProfiles = covatic.getLinkedAudiences();
        logger.info('AudienceProfiles:', audienceProfiles);

        if (audienceProfiles && audienceProfiles.length > 0) {
            window.localStorage.setItem(audienceProfileKey, audienceProfiles);
            logger.info('Covatic audience profiles stored in localStorage.');
        }
    } else {
        logger.warn('Covatic SDK is not ready.');
    }

}

function onConsentRefused() {
    logger.info('Covatic consent has not been granted - no data will be collected');
    // Remove the _audienceProfile if exist on local storage
    if (localStorageUtils.getItem(audienceProfileKey) !== null) {
        localStorageUtils.removeItem(audienceProfileKey);
        logger.info('Covatic audience profile has been removed from localStorage');
    }
    covatic.notifyConsent(false);
}

module.exports = {

    init: function () {
        const storedConsent = localStorageUtils.getItem(localStorageConstants.consentDataKey);
        if (!storedConsent) {
            logger.warning('Failed to initialise covatic: No consent data');
            return;
        }

        const hasCovaticConsent = storedConsent.consentedVendors.includes(sourcepointConstants.vendorIds.covatic);
        if (hasCovaticConsent) {
            onConsentGranted();
        } else {
            onConsentRefused();
        }
    }
};